const axios = window.axios;

function setAuth(token) {
    if (token) {
        localStorage.setItem('token', token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
    }
}

export const api = {
    setAuth,

    register: (data) =>
        axios.post('register', data).then((r) => {
            const token = r.data?.token;
            if (token) {
                setAuth(token);
            }
            return r.data;
        }),

    login: (credentials) =>
        axios.post('login', credentials).then((r) => {
            const token = r.data?.token;
            if (!token) {
                throw new Error('Token mancante nella risposta di login.');
            }
            setAuth(token);
            return r.data;
        }),

    logout: () =>
        axios.post('logout').then((r) => {
            setAuth(null);
            return r.data;
        }),

    getDashboard: (params) => axios.get('dashboard', { params }).then((r) => r.data),

    getAccounts: () => axios.get('accounts').then((r) => r.data),
    createAccount: (data) => axios.post('accounts', data).then((r) => r.data),
    updateAccount: (id, data) => axios.put(`accounts/${id}`, data).then((r) => r.data),
    deleteAccount: (id) => axios.delete(`accounts/${id}`).then((r) => r.data),

    getCategories: () => axios.get('categories').then((r) => r.data),
    createCategory: (data) => axios.post('categories', data).then((r) => r.data),
    updateCategory: (id, data) => axios.put(`categories/${id}`, data).then((r) => r.data),
    deleteCategory: (id) => axios.delete(`categories/${id}`).then((r) => r.data),

    getTransactions: (params) => axios.get('transactions', { params }).then((r) => r.data),
    createTransaction: (data) => axios.post('transactions', data).then((r) => r.data),
    updateTransaction: (id, data) => axios.put(`transactions/${id}`, data).then((r) => r.data),
    deleteTransaction: (id) => axios.delete(`transactions/${id}`).then((r) => r.data),

    uploadImport: (data) => axios.post('imports', data).then((r) => r.data),
    confirmImport: (id, data) => axios.post(`imports/${id}/confirm`, data).then((r) => r.data),

    exportTransactions: (params) => axios.get('exports/transactions', { params }),

    createBackup: () => axios.post('backup', null, { responseType: 'blob' }),
};
